"use strict";

exports.__esModule = true;
exports.memoize = memoize;
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Memoize a function.
 */
function memoize(fn) {
  var lastArgs;
  var lastValue;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (lastArgs !== undefined && (0, _reactFastCompare["default"])(lastArgs, args)) {
      return lastValue;
    }
    lastArgs = args;
    lastValue = fn.apply(void 0, args);
    return lastValue;
  };
}